import { VxeUI } from 'vxe-pc-ui';

export const open = (title, content, options = {
    mask: true,
    maskClosable: true,
    width: '50%',
    escClosable: true,
    showZoom: true,
    resize: true,
    showFooter: true,
    lockView: true,
    showConfirmButton: true,
    showCancelButton: true,
    confirmButtonText: '确定',
    cancelButtonText: '取消',
}) => {
    return new Promise(resolve => {
        VxeUI.modal.open({
            title,
            content,
            ...options,
        }).then(res => resolve(res));
    });
};

export const openUrl = (title, url, options = {
    mask: true,
    maskClosable: true,
    width: '50%',
    escClosable: true,
    showZoom: true,
    resize: true,
    showFooter: true,
    lockView: true,
    showConfirmButton: true,
    showCancelButton: true,
    confirmButtonText: '确定',
    cancelButtonText: '取消',
}) => {
    return new Promise(resolve => {
        VxeUI.modal.open({
            title,
            ...options,
            slots: {
                default: () => {
                    return <iframe src={url} style="display: block;width: 100%;height: 100%;border: 0;frame-border:0;"></iframe>;
                },
            },
        }).then(res => resolve(res));
    });
};
//
// export const openComponent = (title, component, params = {}, options = {
//     mask: true,
//     maskClosable: true,
//     width: '50%',
//     escClosable: true,
//     showZoom: true,
//     resize: true,
//     showMaximize: true,
//     showClose: true,
//     lockView: true,
//     showConfirmButton: true,
//     showCancelButton: true,
//     confirmButtonText: '确定',
//     cancelButtonText: '取消',
//     confirmClosable: false,
//     cancelClosable: true,
// }) => {
//     return new Promise(resolve => {
//         const { showConfirmButton, showCancelButton } = options;
//
//         const componentRef = ref();
//         const modalId = `modal-${(new Date()).getTime()}`;
//         const dialogFooter = ref();
//         const dialogProps = reactive({
//             showFooter: showConfirmButton || showCancelButton,
//         });
//         const dialogExpose = {
//             setFooter (content) {
//                 dialogFooter.value = content;
//             },
//         };
//         VxeUI.modal.open({
//             id: modalId,
//             title,
//             transfer: true,
//             draggable: true,
//             dblclickZoom: true,
//             storage: true,
//             ...options,
//             ...dialogProps,
//             slots: {
//                 default: () => {
//                     return (
//                         <div>
//                             <component dialog={dialogExpose} ref={ (el) => { componentRef.value = el; }} {...params}></component>
//                         </div>);
//                 },
//                 footer: dialogFooter,
//             },
//             onConfirm ({ type, $event }) {
//                 resolve({
//                     type: 'confirm',
//                     modal: {
//                         close () { VxeUI.modal.close(modalId); },
//                     },
//                     component: componentRef.value,
//                     $event,
//                 });
//             },
//         }).then(type => {
//             resolve({ type });
//         });
//     });
// };
//
// // openEditor 打开数据编辑器
// export const openEditor = async (title, editor, params = {}, options = {
//     mask: true,
//     maskClosable: true,
//     width: '50%',
//     escClosable: true,
//     showZoom: true,
//     resize: true,
//     showMaximize: true,
//     showClose: true,
//     showFooter: true,
//     lockView: true,
//     showConfirmButton: true,
//     showCancelButton: true,
//     confirmButtonText: '确定',
//     cancelButtonText: '取消',
//     confirmClosable: false,
//     cancelClosable: true,
// }) => {
//     const { type, modal, component } = await openComponent(title, editor, params, options);
//     if (type === 'confirm') {
//         const res = await component.save();
//         if (res) {
//             modal.close();
//             return Promise.resolve(res);
//         }
//     } else {
//         return Promise.resolve(false);
//     }
// };
